<template>
  <div>
    <el-date-picker
      v-model="pickedTime"
      type="daterange"
      align="right"
      unlink-panels
      range-separator="-"
      :start-placeholder="startPlaceholder"
      :end-placeholder="endPlaceholder"
      :picker-options="pickerOptions"
      size="small"
    ></el-date-picker>
  </div>
</template>

<script>
export default {
  data() {
    return {
      pickedTime: "",
      pickerOptions: {
        shortcuts: [
          {
            text: "最近一周",
            onClick(picker) {
              const end = new Date();
              const start = new Date();
              start.setTime(start.getTime() - 3600 * 1000 * 24 * 7);
              picker.$emit("pick", [start, end]);
            },
          },
          {
            text: "最近一个月",
            onClick(picker) {
              const end = new Date();
              const start = new Date();
              start.setTime(start.getTime() - 3600 * 1000 * 24 * 30);
              picker.$emit("pick", [start, end]);
            },
          },
          {
            text: "最近三个月",
            onClick(picker) {
              const end = new Date();
              const start = new Date();
              start.setTime(start.getTime() - 3600 * 1000 * 24 * 90);
              picker.$emit("pick", [start, end]);
            },
          },
        ],
      },
    };
  },

  props: {
    startPlaceholder: String,
    endPlaceholder: String,
  },

  watch: {
    pickedTime(newTime, oldTime) {
        this.$emit("choosedTime",newTime);
    },
  },
};
</script>